export default __webpack_public_path__ + "static/media/cluster2.04b708e9.png";